import type { StackNavigationOptions } from "@react-navigation/stack";

const defaultNavOptions: StackNavigationOptions = {
  cardStyle: { flex: 1 },
  headerShown: false,
};

export default defaultNavOptions;
